function setHeight(item, resetHeight) {
  const originalTransition = item.style.transition;

  if (resetHeight) {
    item.style.transition = 'none';
  }
  item.style.height = 'auto';

  const fullHeight = item.offsetHeight;

  item.setAttribute('data-height', fullHeight);
  if (resetHeight) {
    item.style.height = 0;
    item.style.transition = originalTransition;
  }
}

const accordion = () => {
  const accordionTriggers = document.querySelectorAll('.js-accordion-trigger');
  const accordionFull = document.querySelectorAll('.js-accordion-full');

  function initAccordion() {
    accordionFull.forEach(item => {
      const isOpen = item.classList.contains('opened');

      if (!isOpen) {
        setHeight(item, true)
      }
    });
  }

  function handleClickAccordion() {
    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        const target = trigger.previousElementSibling;
        const targetHeight = target.dataset.height;
        const isOpen = target.classList.contains('opened');
        const triggerButton = e.currentTarget;
        const triggerTextElement = triggerButton.querySelector('.js-accordion-trigger-text');
        const triggerCloseText = triggerButton.dataset.close;
        const triggerOpenText = triggerButton.dataset.open;

        accordionFull.forEach(item => {
          if (item !== target) {
            const triggerTextElements = item.nextElementSibling.querySelector('.js-accordion-trigger-text');
            item.classList.remove('opened');
            triggerTextElements.innerText = triggerOpenText;
            triggerButton.classList.remove('opened');
            setTimeout(() => {
              item.style.height = 0;
            }, 100);
          }
        });

        if (!isOpen) {
          target.style.height = `${targetHeight}px`;
          triggerTextElement.innerText = triggerCloseText;
          triggerButton.classList.add('opened');

          setTimeout(() => {
            target.classList.add('opened');
          }, 100)
        } else {
          triggerTextElement.innerText = triggerOpenText;
          triggerButton.classList.remove('opened');
          target.classList.remove('opened');
          setTimeout(() => {
            target.style.height = 0;
          }, 200)
        }
      });
    });
  }

  return {
    init() {
      initAccordion();
      handleClickAccordion();
    },
  };
};

window.addEventListener('load', () => {
  accordion().init();
});

window.addEventListener('resize', () => {
  const accordion = document.querySelectorAll('.js-accordion-full');

  accordion.forEach(item => {
    const isOpen = item.classList.contains('opened');

    if (isOpen) {
      setHeight(item, false)
    } else {
      setHeight(item, true)
    }
  })
})
